import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-app_icon-26",
  "use": "icon-app_icon-26-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"icon-app_icon-26\"><g><path d=\"M18.47 2.118L33 9.867v24l-7-.001v-17a2 2 0 00-1.85-1.994l-.15-.005H12a2 2 0 00-2 2v16.999H3v-24l14.53-7.748a1 1 0 01.94 0z\" /><rect fill-opacity=\".6\" x=\"12\" y=\"18\" width=\"12\" height=\"4\" rx=\"1\" /><rect fill-opacity=\".6\" x=\"12\" y=\"24\" width=\"12\" height=\"4\" rx=\"1\" /><rect fill-opacity=\".6\" x=\"12\" y=\"30\" width=\"12\" height=\"4\" rx=\"1\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol